import React from "react";
import { connect } from "react-redux";
import styles from "./style.module.scss";
import { MDBListGroup, MDBListGroupItem } from "mdbreact";
import { Link } from "react-router-dom";
import { getUserInfoByCode } from "~/store/user/userAction";
import cx from "classnames";
import { redirectToMedproId } from "~/store/login/actions";
class MenuBarBottom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderIsAuthenticated = currentLocation => {
    const { IsAuthenticated } = this.props;
    if (IsAuthenticated) {
      return (
        <MDBListGroupItem>
          <Link
            to="/user"
            replace={currentLocation === "/user"}
            className={currentLocation === "/user" ? styles.active : ""}
          >
            <div className={styles.icons}>
              <i className="fal fa-user" />
            </div>
            <div className={styles.text}>Hồ sơ</div>
          </Link>
        </MDBListGroupItem>
      );
    }
    return (
      <MDBListGroupItem
        onClick={() => {
          this.props.redirectToMedproId();
        }}
      >
        <Link to="#">
          <div className={styles.icons}>
            <i className="fal fa-sign-in-alt" />
          </div>
          <div className={styles.text}>Đăng nhập</div>
        </Link>
      </MDBListGroupItem>
    );
  };

  render() {
    const { notification, currentLocation, IsAuthenticated } = this.props;
    return (
      <div
        className={cx(styles.menuBar_bottom, "d-block d-lg-none")}
        ref={this.props.menuBarBottomRef}
      >
        <MDBListGroup className={styles.menuBar_bottom_item}>
          <MDBListGroupItem>
            <Link
              to="/"
              replace={currentLocation === "/"}
              className={currentLocation === "/" ? styles.active : ""}
            >
              <div className={styles.icons}>
                <i className="fal fa-home" />
              </div>
              <div className={styles.text}>Trang chủ</div>
            </Link>
          </MDBListGroupItem>

          <MDBListGroupItem>
            <Link to="/" replace={currentLocation === "/"}>
              <div className={styles.icons}>
                <i className="fal fa-list-alt" />
              </div>
              <div className={styles.text}>Hướng dẫn</div>
            </Link>
          </MDBListGroupItem>
          <MDBListGroupItem>
            <Link
              to={
                IsAuthenticated
                  ? {
                      pathname: "/user",
                      state: { activeItem: 3 }
                    }
                  : "#"
              }
              className={
                currentLocation.includes("/thong-bao") ? styles.active : ""
              }
              onClick={
                IsAuthenticated ? () => {} : this.props.redirectToMedproId
              }
            >
              <div className={styles.icons}>
                <i className="fal fa-bell" />
                {notification && notification.totalNew ? (
                  <span className={styles.message}>
                    {notification.totalNew}
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className={styles.text}>Thông báo </div>
            </Link>
          </MDBListGroupItem>
          {this.renderIsAuthenticated(currentLocation)}
        </MDBListGroup>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated },
    notification
  } = state;
  return {
    IsAuthenticated,
    notification
  };
};

export default connect(mapStateToProps, {
  redirectToMedproId,
  getUserInfoByCode
})(MenuBarBottom);
